import demo from './demo';

(() => {
  if (typeof $ === 'undefined') {
    throw new TypeError('Exempli JavaScript requires jQuery. jQuery must be included before theme.js.');
  }
})();

export default demo;
